module.exports = __webpack_public_path__ + "static/media/refraction-ref.cad92206.png";